export const POCKETBASE_URL = 'https://pb-picking.anacate.com/';

// Dashboard configuration
export const DASHBOARD_CONFIG = {
  // List of statuses to display in the dashboard
  // You can modify this array to show/hide specific statuses
  displayStatuses: [
    'NOT_READY',
    'PACKING',
    'READY',
    'ON_ROUTE',
    'DELIVERED',
    'RETURNED',
  ]
};
